export default {
    tab: '.Bloko-Tabs-Tab',
    tabBody: '.Bloko-Tabs-Body',
    container: '.Bloko-Tabs-Container',
    dropdownData: '.Bloko-Tabs-Dropdown-Data',
    dropdownItem: '.Bloko-Tabs-Dropdown-Item',
    moreButton: '.Bloko-Tabs-More-Button',
};
